import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as stores from '../../stores';
import { RouteComponentProps } from 'easit--routing';
import { BetDetail } from 'desktop--design-library';
import { ProgressContent } from 'common--design-library';
import * as routing from 'easit--routing';
import SimpleBar from 'simplebar-react';
import { Instance } from 'mobx-state-tree';
import { betDetailStore } from '../../models/betDetail';
import { IApplicationStore } from '../../liveStores';
import { FooterContainer } from '../footer/footerContainer';
import { CancelBetResultType, evalFooterVisibility } from 'eTip--common';

interface IBetDetailCommonProps {
    detailStore: Instance<typeof betDetailStore>;
    handleRefresh: () => void;
}

export interface IAppStoreWithTicketDetail {
    betDetail: Instance<typeof betDetailStore>;
}

const LegacyBetDetailCommon = observer((props: IBetDetailCommonProps) => {
    const publicUrl = () => {
        if (!props.detailStore.publicId) {
            return "";
        }
        return `${window.location.origin}/tiket/${props.detailStore.publicId}`; // really relative url (transformed by web url redir)
    }

    return <SimpleBar className="scroll-container without-horizontal-scroll" data-simplebar-force-visible={true}>
        <ProgressContent state={props.detailStore.state}>
            <BetDetail
                title={props.detailStore.title}
                header={props.detailStore.header}
                betOddsList={props.detailStore.betOddsList}
                ticketList={props.detailStore.betTicketList}
                actions={{
                    back: routing.hasPrevLink() && routing.goBack,
                    refresh: props.handleRefresh,
                    print: null
                    // download: this.handleDownload,
                }}
                publicTicketLink={publicUrl()}
                showCancelButton={props.detailStore.showCancelButton}
                cancelMessage={null}
                isCancelLoading={props.detailStore.cancelState === CancelBetResultType.Loading}
            />
        </ProgressContent>
        <FooterContainer canShow={evalFooterVisibility(props.detailStore.state)} />
    </SimpleBar>
});

export interface ILegacyBetDetailRouteProps extends RouteComponentProps<ILegacyBetDetailRouteParams> {
    applicationStore?: IAppStoreWithTicketDetail;
}

export interface ILegacyBetDetailRouteParams {
    ticketId?: number;
}

class LegacyBetDetailRouteBase extends React.Component<ILegacyBetDetailRouteProps>  {
    constructor(props: ILegacyBetDetailRouteProps) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    componentWillMount() {
        this.store.loadAsync(this.props.match.params.ticketId);
    }

    componentWillReceiveProps(nextProps: ILegacyBetDetailRouteProps) {
        if (!!nextProps.match.params.ticketId) {
            this.store.loadAsync(nextProps.match.params.ticketId);
        }
    }

    handleRefresh() {
        this.store.loadAsync(this.props.match.params.ticketId);
    }

    get store() {
        return this.props.applicationStore.betDetail;
    }

    render() {
        return <LegacyBetDetailCommon
            detailStore={this.store}
            handleRefresh={this.handleRefresh}
        />
    }
}

@inject(stores.ApplicationStoreKey)
@observer
export class LegacyBetDetailRoute extends LegacyBetDetailRouteBase {
}

@inject(stores.ApplicationStoreKey)
@observer
export class LegacyBetDetailLiveRoute extends LegacyBetDetailRouteBase {
    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}

export interface ILegacyPublicBetDetailRouteProps extends RouteComponentProps<ILegacyPublicBetDetailRouteParams> {
    applicationStore?: IAppStoreWithTicketDetail;
}

export interface ILegacyPublicBetDetailRouteParams {
    publicTicketId?: string;
}

abstract class LegacyPublicBetDetailRouteBase extends React.Component<ILegacyPublicBetDetailRouteProps>  {
    constructor(props: ILegacyPublicBetDetailRouteProps) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    componentWillMount() {
        this.store.loadPublicAsync(this.props.match.params.publicTicketId);
    }

    componentWillReceiveProps(nextProps: ILegacyPublicBetDetailRouteProps) {
        if (!!nextProps.match.params.publicTicketId)
            this.store.loadPublicAsync(nextProps.match.params.publicTicketId);
    }

    handleRefresh() {
        this.store.loadPublicAsync(this.props.match.params.publicTicketId);
    }

    get store() {
        return this.props.applicationStore.betDetail;
    }

    render() {
        return <LegacyBetDetailCommon
            detailStore={this.store}
            handleRefresh={this.handleRefresh}
        />
    }
}

@inject(stores.ApplicationStoreKey)
@observer
export class LegacyPublicBetDetailRoute extends LegacyPublicBetDetailRouteBase {
}

@inject(stores.ApplicationStoreKey)
@observer
export class LegacyPublicBetDetailLiveRoute extends LegacyPublicBetDetailRouteBase {

    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}